import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { DetailsComponent } from './details.component';
import { BookingComponent } from './booking/booking.component';
import { InquiryComponent } from './inquiry/inquiry.component';
import { PremiumUser } from '../core/premiumUser.guard';

const productRoutes: Routes = [
  { path: 'details/booking/:id', component: BookingComponent, canActivate: [PremiumUser] },
  { path: '', component: HomeComponent },
  { path: 'details/inquiry/:id', component: InquiryComponent,  canActivate: [PremiumUser]}

];

@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class DetailsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/details/details.routes.ts